// #############################################################################
// ZUFLUSS
// #############################################################################
window.chartDetailansichtKategorieZufluss = {
	data: {
		kategorie: [],
	},

	showLoading() {
		this.chart.showLoading()
	},

	hideLoading() {
		this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.Chart("chart_detailansicht_kategorie_zufluss", {
			chart: {
				type: "pie",
				events: {
					render: function () {
						var chart = this,
							series = chart.series,
							allZeros = true
						for (var i = 0; i < series[0].data.length; i++) {
							if (series[0].data[i].y !== 0) {
								allZeros = false
							}
						}
						if (allZeros) {
							chart.showLoading("Keine Daten vorhanden")
						} else {
							chart.hideLoading()
						}
					},
				},
			},

			tooltip: {
				headerFormat: "",
				pointFormatter: function () {
					return `${this.name}<br/><b>${Highcharts.numberFormat(this.y, 0)}€</b>`
				},
				style: {
					fontSize: chartFontSizeMittel,
					textAlign: "center",
				},
			},

			series: this.seriesKategorie(),
		})
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.seriesKategorie()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	seriesKategorie() {
		return [
			{
				id: "kategorie",
				data: this.data.kategorie,
			},
		]
	},
}
// #############################################################################
// ABFLUSS
// #############################################################################
window.chartDetailansichtKategorieAbfluss = {
	data: {
		kategorie: [],
	},

	showLoading() {
		this.chart.showLoading()
	},

	hideLoading() {
		this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.Chart("chart_detailansicht_kategorie_abfluss", {
			chart: {
				type: "pie",
				events: {
					render: function () {
						var chart = this,
							series = chart.series,
							allZeros = true
						for (var i = 0; i < series[0].data.length; i++) {
							if (series[0].data[i].y !== 0) {
								allZeros = false
							}
						}
						if (allZeros) {
							chart.showLoading("Keine Daten vorhanden")
						} else {
							chart.hideLoading()
						}
					},
				},
			},

			tooltip: {
				headerFormat: "",
				pointFormatter: function () {
					return `${this.name}<br/><b>${Highcharts.numberFormat(this.y, 0)}€</b>`
				},
				style: {
					fontSize: chartFontSizeMittel,
					textAlign: "center",
				},
			},

			series: this.seriesKategorie(),
		})
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.seriesKategorie()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	seriesKategorie() {
		return [
			{
				id: "kategorie",
				data: this.data.kategorie,
			},
		]
		// const data = [],
		// 	elemente = document.querySelectorAll(".detailansicht_container .index_kategorie_div .detailansichtelement")

		// if (elemente) {
		// 	elemente.forEach((i) => {
		// 		betrag = parseFloat(i.dataset.betrag)

		// 		const bezeichnung = i.querySelector(".detailbezeichnung").innerHTML,
		// 			farbe = getGradientColor(farbeAusgaben)

		// 		if (betrag < 0) {
		// 			data.push({
		// 				name: bezeichnung,
		// 				y: Math.abs(betrag),
		// 				color: farbe,
		// 			})
		// 		}
		// 	})
		// }

		// return (series = [
		// 	{
		// 		id: "detailansicht_kategorie_abfluss",
		// 		data: data,
		// 	},
		// ])
	},
}
